import { Link, usePage } from "@inertiajs/react"
import type { PropsWithChildren } from "react"

import { cn } from "@/lib/utils"
import {
  partnerSettingsIdentityPath,
  partnerSettingsMarkupPath,
  partnerSettingsNotificationsPath,
  partnerSettingsPricingPath,
  partnerSettingsProfilePath,
  partnerSettingsUserProfilePath,
  partnerSettingsUsersPath,
} from "@/routes"

const tabs = [
  { title: "Details", href: partnerSettingsProfilePath() },
  { title: "Identity", href: partnerSettingsIdentityPath() },
  { title: "Team", href: partnerSettingsUsersPath() },
  { title: "Pricing", href: partnerSettingsPricingPath() },
  { title: "Payments", href: partnerSettingsMarkupPath() },
  { title: "Notifications", href: partnerSettingsNotificationsPath() },
  { title: "Profile", href: partnerSettingsUserProfilePath() },
]

export default function PartnerSettingsLayout({ children }: PropsWithChildren) {
  const { url } = usePage()

  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl/8 font-semibold">Settings</h1>

      {/* Seven tabs run to ~560px, so the strip scrolls on a phone instead of
          pushing the last ones off screen. pb-px keeps the active tab's
          underline inside the scroll box (overflow-x also makes overflow-y
          `auto`), and the border stays on the outer div. */}
      <div className="border-b">
        <nav className="-mb-px flex gap-1 overflow-x-auto pb-px [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {tabs.map((tab) => {
            const matchesThis =
              url === tab.href || url.startsWith(tab.href + "/")
            const longerMatch = tabs.some(
              (other) =>
                other.href !== tab.href &&
                other.href.startsWith(tab.href) &&
                (url === other.href || url.startsWith(other.href + "/")),
            )
            const isActive = matchesThis && !longerMatch
            return (
              <Link
                key={tab.href}
                href={tab.href}
                className={cn(
                  "relative px-3 py-2 text-sm font-medium transition-colors",
                  isActive
                    ? "text-foreground after:bg-foreground after:absolute after:inset-x-0 after:bottom-0 after:h-0.5"
                    : "text-foreground/60 hover:text-foreground",
                )}
              >
                {tab.title}
              </Link>
            )
          })}
        </nav>
      </div>

      <div>{children}</div>
    </div>
  )
}
